import navigateToNextHomeOnboardingPageAction from "@actions/navigateToNextHomeOnboardingPageAction"
import homeOnboardingLoader from "@loaders/homeOnboardingLoader"
import SubscriptionCountPage from "@pages/onboarding/SubscriptionCountPage"
import { Navigate, Outlet } from "react-router-dom"
import HomeAlmostTherePage from "./HomeAlmostTherePage"
import HomeBiggestPainPage from "./HomeBiggestPainPage"
import HomeBlockerPage from "./HomeBlockerPage"
import HomeCommitmentPage from "./HomeCommitmentPage"
import HomeCurrentSetupPage from "./HomeCurrentSetupPage"
import HomeDecisionMomentPage from "./HomeDecisionMomentPage"
import HomeDoingGreatPage from "./HomeDoingGreatPage"
import HomeExperimentingPage from "./HomeExperimentingPage"
import HomeFutureOutcomePage from "./HomeFutureOutcomePage"
import HomeMistakeCostPage from "./HomeMistakeCostPage"
import HomeMustTrackPage from "./HomeMustTrackPage"
import HomeRoomFocusPage from "./HomeRoomFocusPage"
import HomeShareWithWhoPage from "./HomeShareWithWhoPage"
import HomeSpaceConfidencePage from "./HomeSpaceConfidencePage"
import HomeStartHerePage from "./HomeStartHerePage"
import HomeSuccessSignalPage from "./HomeSuccessSignalPage"
import HomeTimeSpentPage from "./HomeTimeSpentPage"
import HomeTopPriorityPage from "./HomeTopPriorityPage"
import HomeUpdateFrequencyPage from "./HomeUpdateFrequencyPage"
import HomeWhyHomeProfilePage from "./HomeWhyHomeProfilePage"

const action = navigateToNextHomeOnboardingPageAction

const onboardingHomeRoutes = [
  {
    path: "/onboarding/home",
    element: <Outlet />,
    loader: homeOnboardingLoader,
    children: [
      {
        element: <Navigate to={`startHere${window.location.search}`} replace />,
        index: true,
      },
      { action, element: <HomeStartHerePage />, path: "startHere" },
      { action, element: <HomeCurrentSetupPage />, path: "currentSetup" },
      { action, element: <HomeRoomFocusPage />, path: "roomFocus" },
      { action, element: <HomeTopPriorityPage />, path: "topPriority" },
      { action, element: <HomeWhyHomeProfilePage />, path: "whyHomeProfile" },
      { action, element: <HomeBiggestPainPage />, path: "biggestPain" },
      { action, element: <HomeUpdateFrequencyPage />, path: "updateFrequency" },
      { action, element: <HomeSpaceConfidencePage />, path: "spaceConfidence" },
      { action, element: <HomeMustTrackPage />, path: "mustTrack" },
      { action, element: <HomeShareWithWhoPage />, path: "shareWithWho" },
      { action, element: <HomeDecisionMomentPage />, path: "decisionMoment" },
      { action, element: <HomeExperimentingPage />, path: "experimenting" },
      { action, element: <HomeDoingGreatPage />, path: "doingGreat" },
      { action, element: <HomeTimeSpentPage />, path: "timeSpent" },
      { action, element: <HomeMistakeCostPage />, path: "mistakeCost" },
      { action, element: <HomeBlockerPage />, path: "blocker" },
      { action, element: <HomeFutureOutcomePage />, path: "futureOutcome" },
      { action, element: <HomeSuccessSignalPage />, path: "successSignal" },
      { action, element: <HomeCommitmentPage />, path: "commitment" },
      {
        action,
        element: <SubscriptionCountPage />,
        path: "subscriptionCount",
      },
      { action, element: <HomeAlmostTherePage />, path: "almostThere" },
    ],
  },
]

export default onboardingHomeRoutes
